import { render, staticRenderFns } from "./StartForm13.vue?vue&type=template&id=001676e7&scoped=true"
import script from "./StartForm13.vue?vue&type=script&lang=ts"
export * from "./StartForm13.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001676e7",
  null
  
)

export default component.exports